// Client-safe constants for the homepage "How I work" A/B test. Server-only
// storage and stats live in lib/ab-test.ts.

export const AB_TEST_NAME = "homepage-how-i-work";

// First-party cookies: which variant the visitor sees, and an anonymous random
// id so each visitor counts once per event. Neither holds personal data.
export const AB_VARIANT_COOKIE = "jw_ab_hiw";
export const AB_VISITOR_COOKIE = "jw_vid";
export const AB_COOKIE_MAX_AGE = 60 * 60 * 24 * 90; // 90 days

export const AB_VARIANTS = ["a", "b"] as const;
export type AbVariant = (typeof AB_VARIANTS)[number];

// The funnel, in order. Every later step only counts for visitors who were
// exposed (saw the section) within the current results window.
export const AB_EVENTS = ["exposure", "read_through", "contact_visit", "contact_submit"] as const;
export type AbEvent = (typeof AB_EVENTS)[number];

export const AB_EVENT_LABELS: Record<AbEvent, string> = {
  exposure: "Saw the section",
  read_through: "Read it all",
  contact_visit: "Visited /contact",
  contact_submit: "Sent a message",
};

export const isAbVariant = (v: unknown): v is AbVariant =>
  typeof v === "string" && (AB_VARIANTS as readonly string[]).includes(v);

export const isAbEvent = (v: unknown): v is AbEvent =>
  typeof v === "string" && (AB_EVENTS as readonly string[]).includes(v);

// Visitor ids are crypto.randomUUID() strings; anything else is rejected.
export const VISITOR_ID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
